export const CONFIG_DATA = 'CONFIG_DATA';
export const CONFIG_DATA_FAILURE = 'CONFIG_DATA_FAILURE';